import JSONAPIClient from '../../JSONAPIClient'

JSONAPIClient.define('vendor', {
  display_name: '',
  name: '',
  vendor_type: '',
  soft_credit_enabled: '',
})
